module.exports = __webpack_public_path__ + "img/61.f54f2dad.png";